import { makeStyles } from 'tss-react/mui'
import { fundingColors as C } from '../../theme/figmaColors'

export const useStyles = makeStyles()(() => ({
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    columnGap: 24,
    rowGap: 16,
    width: '100%',
  },
  divider: {
    gridColumn: '1 / -1',
    height: 1,
    backgroundColor: C.divider,
  },
}))
